module.exports = __webpack_public_path__ + "assets/image-upload.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image-upload.png
// module id = 1662
// module chunks = 7